<template>
  <div>
    <div id="north">
      <header-info cur="1"></header-info>
    </div>
    <div class="list">
      <ul>
        <li
          :class="isActive==1?'on':''"
          @click="isActive=1"
        >个人信息</li>
        <li
          :class="isActive==2?'on':''"
          @click="isActive=2,queryExpInfo.page=1,getExperiment()"
        >我的实验</li>
        <li
          :class="isActive==3?'on':''"
          @click="isActive=3,queryLessonInfo.page=1,getLessonOnline()"
        >我的课程</li>
      </ul>

      <div
        class="mobile mobile-item"
        v-show="isActive==1"
      >
        <div class="person clearfix">
          <div class="head">
            <div class="userhead">
              <img
                :src="this.$store.state.userInfo.avatar?this.$store.state.userInfo.avatar:'-'"
                :onerror="$store.state.defaultHeadImg"
              >
            </div>

          </div>
          <ul id="elList">
            <li>
              <div class="info">姓名：<span>{{name}}</span>
              </div>
            </li>
            <li>
              <div class="info">账号：<span>{{$store.state.userInfo.user_name}}</span></div>
            </li>
            <li>
              <div class="info">身份：<span>{{roleFormater(role)?roleFormater(role):'--'}}</span></div>
            </li>
            <li>
              <div class="info">性别：<span>{{$store.state.userInfo.gender==1?'男': '女'}}</span>
              </div>
            </li>
            <li>
              <div class="info">手机号：<span>{{$store.state.userInfo.mobile?$store.state.userInfo.mobile.substr(0, 3) + '****' + $store.state.userInfo.mobile.substr(7):'--'}}</span>
              </div>
            </li>
            <li>
              <div class="info">院系：<span>{{academy?academy:'--'}}</span></div>
            </li>
            <li>
              <div class="info">专业：<span>{{major?major:'--'}}</span></div>
            </li>
            <li>
              <div class="info">学号：<span>{{s_no?s_no:'--'}}</span></div>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="mobile mobile-item"
        v-show="isActive==2"
      >
        <ul class="mobile-item-list">
          <router-link
            tag="li"
            :to="'/www/experiment?id=' + item.id"
            v-for="item in experimentData"
            :key="item.id"
          >
            <div class="img-wrap">
              <img
                :src="item.experiment.logo"
                :onerror="$store.state.defaultImg"
              />
            </div>
            <div>
              <p class="biaoti">{{item.experiment.title}}</p>
              <p class="p1">
                <span>{{formatSchool(item.experiment.school)}}</span>
                <span class="line">|</span>
                <span>{{item.master_name?item.master_name:'--'}}</span>
              </p>
            </div>
          </router-link>
          <li
            class="no-info"
            v-if="!experimentData.length"
          >暂无数据</li>
        </ul>
        <div
          v-if="experimentData.length<experimentDataCount"
          class="load-more"
          @click="loadMoreExp"
        >更多+</div>
      </div>
      <div
        class="mobile mobile-item"
        v-show="isActive==3 "
      >
        <ul class="mobile-item-list">
          <router-link
            tag="li"
            :to="'/www/lesson_detail?id=' + item.lessonOnline_id+'&isActive='+isActive"
            v-for="item in lessonData"
            :key="item.id"
          >
            <div class="img-wrap">
              <img
                :src="item.lessonOnline.logoPath?item.lessonOnline.logoPath:''"
                :onerror="$store.state.defaultImg"
              />
            </div>
            <div>
              <p class="biaoti">{{item.lessonOnline.title}}</p>
              <p class="p1">
                <span>第一学期</span>
              </p>
              <p class="p1">
                <span>进行第{{item.currentWeek}}周，共{{item.lessonOnline.allTime?item.lessonOnline.allTime:'--'}}周</span>
              </p>
              <p class="p1">
                <span>{{item.lessonOnline.school?formatSchool(item.lessonOnline.school):'--'}}</span>
                <span class="line">|</span>
                <span>{{item.lessonOnline.manager?item.lessonOnline.manager.name:'--'}}</span>
              </p>
            </div>
          </router-link>
          <li
            class="no-info"
            v-if="!lessonData.length"
          >暂无数据</li>
        </ul>
        <div
          v-if="lessonData.length<lessonDataCount"
          class="load-more"
          @click="loadMoreLesson"
        >更多+</div>
      </div>

    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
export default {
  name: 'SearchList',
  components: {
    HeaderInfo
  },
  data() {
    return {
      isActive: '1',
      name: this.$store.state.userInfo.name,
      gender: this.$store.state.userInfo.gender,
      mobile: this.$store.state.userInfo.mobile,
      s_no: '',
      role: '',
      academy: '',
      major: '',
      experimentData: [],
      experimentDataCount: 0,
      lessonData: [],
      lessonDataCount: 0,
      queryExpInfo: {
        page: 1,
        size: 10,
        userprofile_id: '',
        experiment_title: '',
        expJoinType: 0,
        audit_status: 1
      },
      queryLessonInfo: {
        page: 1,
        size: 10,
        userProfile_id: this.$store.state.userInfo.profile_id,
        audit_status: 1,
        lessonOnline_status: 5
      },
      schoolData: []

    }
  },
  mounted() {
    this.getSchool()
    this.getUserInfo()
    this.getExperiment()
    this.getLessonOnline()
  },
  computed: {
    localUser() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    roleFormater(role) {
      if (role === '0' || role === '') {
        return '系统管理员'
      }
      return this.$store.state.dict_role[role]
    },

    // 计算当前时间处于第几周
    getWeek (dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = d2 - d1
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(days / 7)
      return num
    },
    formatWeek(val) {
      var num = this.getWeek(val)
      return num
    },
    formatSchool(id) {
      for (let i = 0; i < this.schoolData.length; i++) {
        if (id === this.schoolData[i].id) {
          return this.schoolData[i].title
        }
      }
    },
    // 实验
    async getExperiment() {
      this.queryExpInfo.userprofile_id = this.localUser.profile_id
      await this.$http.get('/experimentstudent/', {
        params: this.queryExpInfo
      }).then((data) => {
        if (this.queryExpInfo.page === 1) {
          this.experimentData = data.results
        } else {
          this.experimentData = this.experimentData.concat(data.results)
        }
        this.experimentDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    loadMoreExp() {
      this.queryExpInfo.page = this.queryExpInfo.page + 1
      this.getExperiment()
    },

    // 课程
    async getLessonOnline() {
      await this.$http.get('/online_student/', {
        params: this.queryLessonInfo
      }).then((data) => {
        for (let i = 0; i < data.results.length; i++) {
          data.results[i].currentWeek = data.results[i].lessonOnline.startTime ? this.getWeek(data.results[i].lessonOnline.startTime) : '--'
          data.results[i].lessonOnline.brief = data.results[i].lessonOnline.brief.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi)
        }
        if (this.queryLessonInfo.page === 1) {
          this.lessonData = data.results
        } else {
          this.lessonData = this.lessonData.concat(data.results)
        }
        this.lessonDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    loadMoreLesson() {
      this.queryLessonInfo.page = this.queryLessonInfo.page + 1
      this.getLessonOnline()
    },

    async getUserInfo() {
      const url = '/userprofile/' + this.$store.state.userInfo.profile_id + '/'
      await this.$http.get(url).then((data) => {
        this.s_no = data.s_no
        this.role = data.role
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        if (data.academy_id) {
          this.searchAcademy(data.academy.id)
          userInfo.academy_id = data.academy.id
          this.$store.commit('setUserInfo', userInfo)
        }
        if (data.major_id) {
          this.searchMajor(data.major.id)
        }
      })
    },
    async searchAcademy(id) {
      const url = '/academy/' + id + '/'
      await this.$http.get(url).then((data) => {
        const userInfo = JSON.parse(JSON.stringify(this.$store.state.userInfo))
        userInfo.academy_name = data.title
        this.$store.commit('setUserInfo', userInfo)
        this.academy = data.title
      }).catch((error) => {
        console.log(error)
      })
    },
    async searchMajor(id) {
      const url = '/major/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.major = data.title
      }).catch((error) => {
        console.log(error)
      })
    },
    async getSchool() {
      const params = {
        page: 1,
        size: 10000,
        status: 1
      }
      await this.$http.get('/school/', { params }).then((data) => {
        this.schoolData = data.results
      }).catch((error) => {
        console.log(error)
      })
    }

  }
}
</script>

<style lang="less" scoped>
.list > ul {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #c9c9c9;
  li {
    line-height: 30px;
    border-bottom: 2px solid transparent;
    &.on {
      border-bottom: 2px solid #73D6CA;
    }
  }
}
.list-info {
  padding: 10px 15px;
  li {
    margin-bottom: 20px;
    border-bottom: 1px solid #efefef;
    padding-bottom: 5px;
    & > p {
      &:first-child {
        font-size: 15px;
        color: #333;
        margin-bottom: 10px;
      }
      &:nth-child(2n) {
        font-size: 14px;
        color: #999;
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      &:last-child {
        font-size: 12px;
        color: #ccc;
      }
    }
  }
}
.no-info {
  text-align: center;
  border: none !important;
}
.mobile-item-list {
  flex-wrap: nowrap;
  flex-direction: column;
  li {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .img-wrap {
      width: 40%;
      height: 120px;
      margin-right: 10px;
    }
    & > div {
      &:last-child {
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 1;
      }
    }
  }
}
.mobile-item {
  .person {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .userhead {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    ul {
      margin-top: 20px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
.load-more {
  width: 100px;
  height: 30px;
  border: 1px solid #73D6CA;
  text-align: center;
  line-height: 30px;
  color: #73D6CA;
  margin: 20px auto;
  position: relative;
  z-index: 100;
}
</style>
